import React from "react";

const TotalPayrollNormalization = ({ row }) => {
  return <div>{row?.totalPayrolls?.toLocaleString()}</div>;
};

export default TotalPayrollNormalization;
